import { ButtonGroup, SIZE, SHAPE, MODE } from 'baseui/button-group';
import { Button } from 'baseui/button';
// icons
import { MdOutlineAutorenew } from "react-icons/md";
import { IoHandRightOutline, IoStopOutline } from "react-icons/io5";
import { AccessRoles, useHasRole } from '../../../hooks/useHasRole';

export type AggregateOperationModeSelectProps = {
  isMan: boolean,
  isOff: boolean,
  isAuto: boolean,
  setMan: any,
  setAuto: any,
  setOff: any,
  isCompact: boolean,
}



const OperationModeSelect = (props: AggregateOperationModeSelectProps) => {
  const selected = props.isAuto ? 0 : (props.isMan ? 2 : 1);
  const sizeT = props.isCompact ? SIZE.large : SIZE.large;
  const hasAccessWrite = useHasRole(AccessRoles.Object.Write);
  return (
    <ButtonGroup
      size={sizeT}
      shape={SHAPE.default}
      selected={selected}
      mode={MODE.radio}
      disabled={!hasAccessWrite}
    >
      <Button onClick={(e) => { e.stopPropagation();  e.preventDefault(); props.setAuto();}} overrides={{
        BaseButton: {
          style: ({
            $theme,
            $isSelected,
          }: any) => ({
            borderTopLeftRadius: $theme.borders.radius400,
            borderBottomLeftRadius: $theme.borders.radius400,
            borderBottomRightRadius: 0,
            borderTopRightRadius: 0,
            color: $isSelected ? $theme.colors.accent200 : $theme.colors.buttonBackground
          })
        }
      }}>
        <MdOutlineAutorenew size='2em'></MdOutlineAutorenew>
      </Button>
      <Button onClick={(e) => {e.stopPropagation(); e.preventDefault(); props.setOff();}} overrides={{
        BaseButton: {
          style: ({
            $theme,
            $isSelected,
          }: any) => ({
            borderRadius: 0,
            color: $isSelected ? $theme.colors.primaryB : $theme.colors.buttonBackground
          })
        }
      }}>
        <IoStopOutline size='2em'></IoStopOutline>
      </Button>
      <Button onClick={(e) => { e.stopPropagation(); e.preventDefault(); props.setMan();}} overrides={{
        BaseButton: {
          style: ({
            $theme,
            $isSelected,
          }: any) => ({
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: $theme.borders.radius400,
            borderTopRightRadius: $theme.borders.radius400,
            color: $isSelected ? $theme.colors.warning : $theme.colors.buttonBackground
          })
        }
      }}>
        <IoHandRightOutline size='2em' />
      </Button>
    </ButtonGroup>
  );
};

export default OperationModeSelect;